var _defs, _polygon, _polygon2, _polygon3, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _line, _line2, _line3, _line4, _line5, _line6, _line7, _line8, _line9, _line0, _line1, _line10, _line11, _line12, _line13, _line14, _line15, _line16, _line17, _line18, _line19, _line20, _line21, _line22, _line23, _line24, _line25, _line26, _line27, _line28, _line29, _line30, _line31, _line32, _line33, _line34, _line35, _line36, _line37, _line38, _line39, _line40, _line41, _line42, _line43, _line44, _line45, _line46, _line47, _line48, _line49, _line50, _line51, _line52, _line53, _line54, _line55, _line56, _line57, _line58, _line59, _line60;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGuideMaterial13(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 567.18 283.71",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#f04e23;}.cls-2{fill:url(#linear-gradient);}.cls-3{fill:url(#linear-gradient-2);}.cls-4{fill:#fff;}.cls-5{fill:#812990;}.cls-6{fill:#6b7b84;}.cls-7{fill:#231f20;}.cls-8{fill:none;stroke:#ffcb05;stroke-miterlimit:10;stroke-width:0.25px;}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 541.57,
    y1: 262.26,
    x2: 567.05,
    y2: 262.26,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#d60f84"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#812990"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 0.12,
    y1: 248.16,
    x2: 524.53,
    y2: 248.16,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#d60f84"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#812990"
  })))), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "567.05 283.5 524.53 212.63 482.01 283.5 567.05 283.5"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "541.57 241.03 567.05 283.5 567.05 241.03 541.57 241.03"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "0.13 212.72 524.53 212.72 482.01 283.59 0.13 283.59 0.13 212.72"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M197.23,256.87l-2.74-3.25-.72.82v2.43h-.9v-7.23h.9v3.73l3.19-3.73h1.13l-3,3.42,3.28,3.81Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M202.44,256.87v-.6a2.26,2.26,0,0,1-1.74.73,1.75,1.75,0,0,1-1.82-1.74,1.7,1.7,0,0,1,1.82-1.72,2.23,2.23,0,0,1,1.74.71v-.95c0-.69-.57-1.09-1.33-1.09a2.08,2.08,0,0,0-1.6.72l-.38-.56a2.78,2.78,0,0,1,2.09-.87c1.12,0,2,.5,2,1.77v3.6Zm0-1.11v-1a1.76,1.76,0,0,0-1.43-.64,1.15,1.15,0,1,0,0,2.28A1.74,1.74,0,0,0,202.44,255.76Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M208.43,256.87v-3.43c0-.93-.48-1.21-1.18-1.21a2,2,0,0,0-1.55.81v3.83h-.81v-5.24h.81v.76a2.57,2.57,0,0,1,1.87-.89,1.49,1.49,0,0,1,1.66,1.69v3.68Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M210.86,258.2l.41-.59a2,2,0,0,0,1.7.71,1.49,1.49,0,0,0,1.69-1.53V256a2.22,2.22,0,0,1-1.76.93c-1.37,0-2.33-1-2.33-2.71s1-2.72,2.33-2.72a2.17,2.17,0,0,1,1.76.93v-.8h.81v5.16c0,1.66-1.22,2.2-2.5,2.2A2.66,2.66,0,0,1,210.86,258.2Zm3.8-2.84v-2.3a2,2,0,0,0-1.56-.83c-1.06,0-1.69.83-1.69,2s.63,2,1.69,2A2,2,0,0,0,214.66,255.36Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M220.37,256.87v-.6a2.23,2.23,0,0,1-1.73.73,1.74,1.74,0,0,1-1.82-1.74,1.7,1.7,0,0,1,1.82-1.72,2.21,2.21,0,0,1,1.73.71v-.95c0-.69-.56-1.09-1.32-1.09a2,2,0,0,0-1.6.72l-.38-.56a2.75,2.75,0,0,1,2.09-.87c1.12,0,2,.5,2,1.77v3.6Zm0-1.11v-1a1.73,1.73,0,0,0-1.43-.64,1.15,1.15,0,1,0,0,2.28A1.71,1.71,0,0,0,220.37,255.76Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M222.82,256.87v-5.24h.82v.84a2.26,2.26,0,0,1,1.74-1v.84l-.31,0a1.9,1.9,0,0,0-1.43.83v3.71Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M226.1,254.25a2.59,2.59,0,1,1,2.59,2.75A2.57,2.57,0,0,1,226.1,254.25Zm4.32,0a1.76,1.76,0,1,0-1.73,2A1.82,1.82,0,0,0,230.42,254.25Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M232.3,254.25a2.59,2.59,0,1,1,2.59,2.75A2.57,2.57,0,0,1,232.3,254.25Zm4.32,0a1.76,1.76,0,1,0-1.73,2A1.82,1.82,0,0,0,236.62,254.25Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M241.64,256.87v-7.23h4.73v.8h-3.83v2.33h3.76v.8h-3.76v2.5h3.83v.8Z"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M251.56,256.87v-.78a2.2,2.2,0,0,1-1.76.91c-1.37,0-2.33-1-2.33-2.74s1-2.76,2.33-2.76a2.17,2.17,0,0,1,1.76.93v-2.79h.82v7.23Zm0-1.43v-2.36a1.93,1.93,0,0,0-1.56-.85c-1.06,0-1.69.87-1.69,2s.63,2,1.69,2A1.94,1.94,0,0,0,251.56,255.44Z"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M257.54,256.87v-.74a2.58,2.58,0,0,1-1.87.87,1.48,1.48,0,0,1-1.67-1.67v-3.7h.82v3.45c0,.92.46,1.19,1.18,1.19a2,2,0,0,0,1.54-.79v-3.85h.81v5.24Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M259.67,254.25a2.59,2.59,0,0,1,2.61-2.75,2.23,2.23,0,0,1,1.92.91l-.54.49a1.56,1.56,0,0,0-1.33-.67,2,2,0,0,0,0,4,1.59,1.59,0,0,0,1.33-.68l.54.5a2.23,2.23,0,0,1-1.92.91A2.6,2.6,0,0,1,259.67,254.25Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M268.62,256.87v-.6a2.23,2.23,0,0,1-1.73.73,1.74,1.74,0,0,1-1.82-1.74,1.7,1.7,0,0,1,1.82-1.72,2.21,2.21,0,0,1,1.73.71v-.95c0-.69-.56-1.09-1.32-1.09a2,2,0,0,0-1.6.72l-.38-.56a2.75,2.75,0,0,1,2.09-.87c1.12,0,2,.5,2,1.77v3.6Zm0-1.11v-1a1.73,1.73,0,0,0-1.43-.64,1.15,1.15,0,1,0,0,2.28A1.71,1.71,0,0,0,268.62,255.76Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M271.24,255.77v-3.42h-.87v-.72h.87V250.2h.82v1.43h1.06v.72h-1.06v3.25c0,.39.17.67.52.67a.76.76,0,0,0,.55-.23l.24.62a1.3,1.3,0,0,1-1,.34A1.08,1.08,0,0,1,271.24,255.77Z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M274.12,250.35a.56.56,0,0,1,.55-.56.55.55,0,0,1,.54.56.54.54,0,0,1-.54.54A.55.55,0,0,1,274.12,250.35Zm.14,6.52v-5.24h.81v5.24Z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M276.39,254.25A2.59,2.59,0,1,1,279,257,2.58,2.58,0,0,1,276.39,254.25Zm4.33,0a1.76,1.76,0,1,0-1.74,2A1.82,1.82,0,0,0,280.72,254.25Z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M286.44,256.87v-3.43c0-.93-.48-1.21-1.18-1.21a2,2,0,0,0-1.55.81v3.83h-.81v-5.24h.81v.76a2.57,2.57,0,0,1,1.87-.89,1.49,1.49,0,0,1,1.66,1.69v3.68Z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M291.72,256.87v-7.23h4.73v.8h-3.83v2.33h3.76v.8h-3.76v3.3Z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M297.35,254.25a2.59,2.59,0,1,1,2.59,2.75A2.58,2.58,0,0,1,297.35,254.25Zm4.33,0a1.76,1.76,0,1,0-1.74,2A1.82,1.82,0,0,0,301.68,254.25Z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M307.39,256.87v-.74a2.53,2.53,0,0,1-1.86.87,1.47,1.47,0,0,1-1.67-1.67v-3.7h.81v3.45c0,.92.47,1.19,1.18,1.19a2,2,0,0,0,1.54-.79v-3.85h.81v5.24Z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M313.37,256.87v-3.43c0-.93-.48-1.21-1.18-1.21a2.05,2.05,0,0,0-1.55.81v3.83h-.81v-5.24h.81v.76a2.6,2.6,0,0,1,1.88-.89,1.48,1.48,0,0,1,1.65,1.69v3.68Z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M319.6,256.87v-.78a2.2,2.2,0,0,1-1.76.91c-1.37,0-2.33-1-2.33-2.74s1-2.76,2.33-2.76a2.17,2.17,0,0,1,1.76.93v-2.79h.82v7.23Zm0-1.43v-2.36a1.93,1.93,0,0,0-1.56-.85c-1.06,0-1.69.87-1.69,2s.63,2,1.69,2A1.94,1.94,0,0,0,319.6,255.44Z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M325.31,256.87v-.6a2.22,2.22,0,0,1-1.73.73,1.74,1.74,0,0,1-1.82-1.74,1.7,1.7,0,0,1,1.82-1.72,2.19,2.19,0,0,1,1.73.71v-.95c0-.69-.56-1.09-1.32-1.09a2.06,2.06,0,0,0-1.6.72l-.38-.56a2.76,2.76,0,0,1,2.09-.87c1.12,0,2,.5,2,1.77v3.6Zm0-1.11v-1a1.73,1.73,0,0,0-1.43-.64,1.15,1.15,0,1,0,0,2.28A1.71,1.71,0,0,0,325.31,255.76Z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M327.93,255.77v-3.42h-.87v-.72h.87V250.2h.82v1.43h1.06v.72h-1.06v3.25c0,.39.17.67.52.67a.74.74,0,0,0,.55-.23l.24.62a1.29,1.29,0,0,1-1,.34A1.08,1.08,0,0,1,327.93,255.77Z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M330.81,250.35a.56.56,0,0,1,.55-.56.55.55,0,0,1,.55.56.54.54,0,0,1-.55.54A.55.55,0,0,1,330.81,250.35Zm.14,6.52v-5.24h.81v5.24Z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M333.09,254.25a2.59,2.59,0,1,1,2.59,2.75A2.57,2.57,0,0,1,333.09,254.25Zm4.32,0a1.76,1.76,0,1,0-1.73,2A1.82,1.82,0,0,0,337.41,254.25Z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M343.13,256.87v-3.43c0-.93-.47-1.21-1.18-1.21a2.05,2.05,0,0,0-1.55.81v3.83h-.81v-5.24h.81v.76a2.6,2.6,0,0,1,1.88-.89,1.48,1.48,0,0,1,1.65,1.69v3.68Z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M348.41,256.87v-7.23h2.9a2.18,2.18,0,1,1,0,4.36h-2v2.87Zm4.24-5.05a1.35,1.35,0,0,0-1.44-1.38h-1.9v2.75h1.9A1.34,1.34,0,0,0,352.65,251.82Z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M353.56,256.38a.6.6,0,1,1,.6.6A.61.61,0,0,1,353.56,256.38Z"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M359,256.87v-7.23h.89v6.43h3.36v.8Z"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M364.18,255.77v-3.42h-.87v-.72h.87V250.2H365v1.43h1.07v.72H365v3.25c0,.39.18.67.52.67a.79.79,0,0,0,.56-.23l.23.62a1.27,1.27,0,0,1-1,.34A1.08,1.08,0,0,1,364.18,255.77Z"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M371,256.87v-.78a2.21,2.21,0,0,1-1.77.91c-1.37,0-2.33-1-2.33-2.74s1-2.76,2.33-2.76a2.2,2.2,0,0,1,1.77.93v-2.79h.81v7.23Zm0-1.43v-2.36a2,2,0,0,0-1.56-.85c-1.07,0-1.69.87-1.69,2s.62,2,1.69,2A2,2,0,0,0,371,255.44Z"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M373.27,256.38a.6.6,0,0,1,.6-.6.61.61,0,0,1,.6.6.62.62,0,0,1-.6.6A.61.61,0,0,1,373.27,256.38Z"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M165.22,269.87v-7.22h2.9a2.18,2.18,0,1,1,0,4.35h-2v2.87Zm4.24-5.05a1.34,1.34,0,0,0-1.44-1.37h-1.9v2.75H168A1.34,1.34,0,0,0,169.46,264.82Z"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M174.6,269.87v-.59a2.25,2.25,0,0,1-1.73.72,1.73,1.73,0,0,1-1.82-1.73,1.7,1.7,0,0,1,1.82-1.72,2.18,2.18,0,0,1,1.73.7v-.94c0-.7-.56-1.1-1.32-1.1a2,2,0,0,0-1.6.73l-.38-.56a2.73,2.73,0,0,1,2.09-.87c1.12,0,2,.5,2,1.77v3.59Zm0-1.1v-1a1.76,1.76,0,0,0-1.43-.64,1.15,1.15,0,1,0,0,2.29A1.74,1.74,0,0,0,174.6,268.77Z"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M180.85,269.87v-.78a2.21,2.21,0,0,1-1.77.91c-1.36,0-2.33-1-2.33-2.74s1-2.75,2.33-2.75a2.21,2.21,0,0,1,1.77.92v-2.78h.81v7.22Zm0-1.43v-2.36a2,2,0,0,0-1.56-.84c-1.06,0-1.69.86-1.69,2s.63,2,1.69,2A1.92,1.92,0,0,0,180.85,268.44Z"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M189.6,269.87v-3.55c0-.66-.28-1.08-1-1.08a1.78,1.78,0,0,0-1.39.8v3.83h-.81v-3.55c0-.66-.27-1.08-1-1.08a1.82,1.82,0,0,0-1.38.81v3.82h-.81v-5.23h.81v.76a2.28,2.28,0,0,1,1.7-.89,1.34,1.34,0,0,1,1.4,1,2.2,2.2,0,0,1,1.75-1c1,0,1.47.53,1.47,1.58v3.78Z"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M191.74,267.25a2.59,2.59,0,1,1,2.59,2.75A2.57,2.57,0,0,1,191.74,267.25Zm4.32,0a1.75,1.75,0,1,0-1.73,2A1.81,1.81,0,0,0,196.06,267.25Z"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M202,269.87v-.78a2.21,2.21,0,0,1-1.77.91c-1.37,0-2.33-1-2.33-2.74s1-2.75,2.33-2.75a2.22,2.22,0,0,1,1.77.92v-2.78h.81v7.22Zm0-1.43v-2.36a2,2,0,0,0-1.56-.84c-1.07,0-1.69.86-1.69,2s.62,2,1.69,2A2,2,0,0,0,202,268.44Z"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M207.75,269.87v-.59A2.28,2.28,0,0,1,206,270a1.74,1.74,0,0,1-1.82-1.73,1.7,1.7,0,0,1,1.82-1.72,2.22,2.22,0,0,1,1.74.7v-.94c0-.7-.57-1.1-1.32-1.1a2.06,2.06,0,0,0-1.61.73l-.38-.56a2.74,2.74,0,0,1,2.09-.87c1.12,0,2,.5,2,1.77v3.59Zm0-1.1v-1a1.79,1.79,0,0,0-1.43-.64,1.15,1.15,0,1,0,0,2.29A1.77,1.77,0,0,0,207.75,268.77Z"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M210,271.18a1.08,1.08,0,0,0,.44.09.75.75,0,0,0,.78-.55l.35-.79-2.19-5.29h.89l1.73,4.29,1.74-4.29h.88L212,270.93A1.56,1.56,0,0,1,210.5,272a2.62,2.62,0,0,1-.58-.08Z"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M218.78,269.87v-.59a2.26,2.26,0,0,1-1.73.72,1.73,1.73,0,0,1-1.82-1.73,1.7,1.7,0,0,1,1.82-1.72,2.2,2.2,0,0,1,1.73.7v-.94c0-.7-.56-1.1-1.32-1.1a2.06,2.06,0,0,0-1.61.73l-.37-.56a2.71,2.71,0,0,1,2.09-.87c1.11,0,2,.5,2,1.77v3.59Zm0-1.1v-1a1.78,1.78,0,0,0-1.43-.64,1.15,1.15,0,1,0,0,2.29A1.75,1.75,0,0,0,218.78,268.77Z"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M230.25,269.87v-6.08l-2.45,6.08h-.37L225,263.79v6.08h-.9v-7.22h1.29l2.25,5.56,2.24-5.56h1.29v7.22Z"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M232.5,267.25a2.59,2.59,0,1,1,2.59,2.75A2.57,2.57,0,0,1,232.5,267.25Zm4.32,0a1.75,1.75,0,1,0-3.46,0,1.75,1.75,0,1,0,3.46,0Z"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M242.8,269.87v-.78A2.21,2.21,0,0,1,241,270c-1.36,0-2.33-1-2.33-2.74s1-2.75,2.33-2.75a2.22,2.22,0,0,1,1.77.92v-2.78h.81v7.22Zm0-1.43v-2.36a2,2,0,0,0-1.56-.84c-1.07,0-1.69.86-1.69,2s.62,2,1.69,2A1.94,1.94,0,0,0,242.8,268.44Z"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M244.93,267.25a2.62,2.62,0,0,1,2.58-2.74,2.54,2.54,0,0,1,2.51,2.81v.2H245.8a1.83,1.83,0,0,0,1.87,1.81,2.29,2.29,0,0,0,1.63-.67l.39.53a2.89,2.89,0,0,1-2.08.81A2.6,2.6,0,0,1,244.93,267.25Zm2.57-2.07a1.73,1.73,0,0,0-1.71,1.73h3.43A1.69,1.69,0,0,0,247.5,265.18Z"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M251.48,271.25l-.41-.34a1.63,1.63,0,0,0,.7-1l-.15,0a.53.53,0,0,1-.52-.56.58.58,0,0,1,.57-.58.73.73,0,0,1,.69.82A2.09,2.09,0,0,1,251.48,271.25Z"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M256.59,269.87v-7.22h2.91a2.18,2.18,0,1,1,0,4.35h-2v2.87Zm4.24-5.05a1.34,1.34,0,0,0-1.44-1.37h-1.9v2.75h1.9A1.34,1.34,0,0,0,260.83,264.82Z"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M266.46,269.87v-.73a2.61,2.61,0,0,1-1.87.86,1.48,1.48,0,0,1-1.67-1.67v-3.69h.82v3.44c0,.93.46,1.2,1.18,1.2a2,2,0,0,0,1.54-.79v-3.85h.81v5.23Z"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M269.06,268.78v-3.43h-.87v-.71h.87v-1.43h.82v1.43h1.06v.71h-1.06v3.25c0,.39.17.68.52.68a.74.74,0,0,0,.55-.23l.24.62a1.33,1.33,0,0,1-1,.33A1.07,1.07,0,0,1,269.06,268.78Z"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M275.35,269.87v-.59a2.26,2.26,0,0,1-1.73.72,1.73,1.73,0,0,1-1.82-1.73,1.7,1.7,0,0,1,1.82-1.72,2.2,2.2,0,0,1,1.73.7v-.94c0-.7-.56-1.1-1.32-1.1a2,2,0,0,0-1.6.73l-.38-.56a2.71,2.71,0,0,1,2.09-.87c1.12,0,2,.5,2,1.77v3.59Zm0-1.1v-1a1.76,1.76,0,0,0-1.43-.64,1.15,1.15,0,1,0,0,2.29A1.74,1.74,0,0,0,275.35,268.77Z"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M277.8,269.87v-7.22h.82v7.22Z"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M280.1,263.35a.55.55,0,0,1,.55-.55.55.55,0,0,1,.55.55.54.54,0,0,1-.55.54A.55.55,0,0,1,280.1,263.35Zm.14,6.52v-5.23h.81v5.23Z"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M282.24,269.18l.41-.59a2.37,2.37,0,0,0,1.72.75c.8,0,1.25-.38,1.25-.9,0-1.27-3.24-.49-3.24-2.42,0-.83.69-1.51,1.94-1.51a2.64,2.64,0,0,1,1.94.76l-.38.56a2,2,0,0,0-1.56-.66c-.72,0-1.16.36-1.16.82,0,1.14,3.24.39,3.24,2.43,0,.88-.71,1.58-2,1.58A2.8,2.8,0,0,1,282.24,269.18Z"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M291,269.87v-.59a2.26,2.26,0,0,1-1.73.72,1.73,1.73,0,0,1-1.82-1.73,1.7,1.7,0,0,1,1.82-1.72,2.2,2.2,0,0,1,1.73.7v-.94c0-.7-.56-1.1-1.32-1.1a2,2,0,0,0-1.6.73l-.38-.56a2.71,2.71,0,0,1,2.09-.87c1.11,0,2,.5,2,1.77v3.59Zm0-1.1v-1a1.76,1.76,0,0,0-1.43-.64,1.15,1.15,0,1,0,0,2.29A1.74,1.74,0,0,0,291,268.77Z"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M297.23,269.87v-.78a2.19,2.19,0,0,1-1.76.91c-1.37,0-2.33-1-2.33-2.74s1-2.75,2.33-2.75a2.19,2.19,0,0,1,1.76.92v-2.78h.82v7.22Zm0-1.43v-2.36a2,2,0,0,0-1.56-.84c-1.06,0-1.69.86-1.69,2s.63,2,1.69,2A1.92,1.92,0,0,0,297.23,268.44Z"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M303,269.87v-.59a2.28,2.28,0,0,1-1.74.72,1.74,1.74,0,0,1-1.82-1.73,1.7,1.7,0,0,1,1.82-1.72,2.22,2.22,0,0,1,1.74.7v-.94c0-.7-.57-1.1-1.33-1.1a2.06,2.06,0,0,0-1.6.73l-.38-.56a2.74,2.74,0,0,1,2.09-.87c1.12,0,2,.5,2,1.77v3.59Zm0-1.1v-1a1.79,1.79,0,0,0-1.43-.64,1.15,1.15,0,1,0,0,2.29A1.77,1.77,0,0,0,303,268.77Z"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M309,269.87l-1.87-2.35-.88.86v1.49h-.81v-7.22h.81v4.77l2.75-2.78h1L307.67,267l2.33,2.86Z"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M311.18,271.25l-.41-.34a1.65,1.65,0,0,0,.71-1l-.16,0a.53.53,0,0,1-.52-.56.58.58,0,0,1,.58-.58c.37,0,.68.3.68.82A2.09,2.09,0,0,1,311.18,271.25Z"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M320.67,269.87l-2.75-3.25-.72.83v2.42h-.9v-7.22h.9v3.72l3.19-3.72h1.13l-3,3.42,3.28,3.8Z"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M325.87,269.87v-.59a2.27,2.27,0,0,1-1.74.72,1.74,1.74,0,0,1-1.82-1.73,1.7,1.7,0,0,1,1.82-1.72,2.21,2.21,0,0,1,1.74.7v-.94c0-.7-.57-1.1-1.32-1.1a2.06,2.06,0,0,0-1.61.73l-.38-.56a2.74,2.74,0,0,1,2.09-.87c1.12,0,2,.5,2,1.77v3.59Zm0-1.1v-1a1.79,1.79,0,0,0-1.43-.64,1.15,1.15,0,1,0,0,2.29A1.77,1.77,0,0,0,325.87,268.77Z"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M328.48,268.78v-3.43h-.87v-.71h.87v-1.43h.82v1.43h1.07v.71H329.3v3.25c0,.39.18.68.52.68a.79.79,0,0,0,.56-.23l.24.62a1.35,1.35,0,0,1-1,.33A1.07,1.07,0,0,1,328.48,268.78Z"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M335.05,269.87v-3.44c0-.93-.47-1.19-1.18-1.19a2,2,0,0,0-1.54.81v3.82h-.81v-7.22h.81v2.75a2.5,2.5,0,0,1,1.86-.89,1.47,1.47,0,0,1,1.67,1.67v3.69Z"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M343.8,269.87v-3.55c0-.66-.28-1.08-1-1.08a1.78,1.78,0,0,0-1.39.8v3.83h-.81v-3.55c0-.66-.27-1.08-1-1.08a1.82,1.82,0,0,0-1.38.81v3.82h-.81v-5.23h.81v.76a2.28,2.28,0,0,1,1.7-.89,1.34,1.34,0,0,1,1.4,1,2.2,2.2,0,0,1,1.75-1c1,0,1.47.53,1.47,1.58v3.78Z"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M349.52,269.87v-.59a2.28,2.28,0,0,1-1.74.72,1.74,1.74,0,0,1-1.82-1.73,1.7,1.7,0,0,1,1.82-1.72,2.22,2.22,0,0,1,1.74.7v-.94c0-.7-.57-1.1-1.33-1.1a2.06,2.06,0,0,0-1.6.73l-.38-.56a2.74,2.74,0,0,1,2.09-.87c1.12,0,2,.5,2,1.77v3.59Zm0-1.1v-1a1.79,1.79,0,0,0-1.43-.64,1.15,1.15,0,1,0,0,2.29A1.77,1.77,0,0,0,349.52,268.77Z"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M355.51,269.87v-3.42c0-.93-.48-1.21-1.18-1.21a2,2,0,0,0-1.55.81v3.82H352v-5.23h.81v.76a2.54,2.54,0,0,1,1.87-.89,1.48,1.48,0,0,1,1.66,1.69v3.67Z"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M361.74,269.87v-.78A2.2,2.2,0,0,1,360,270c-1.37,0-2.33-1-2.33-2.74s1-2.75,2.33-2.75a2.19,2.19,0,0,1,1.76.92v-2.78h.81v7.22Zm0-1.43v-2.36a2,2,0,0,0-1.56-.84c-1.06,0-1.69.86-1.69,2s.63,2,1.69,2A1.92,1.92,0,0,0,361.74,268.44Z"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M367.71,269.87v-.73a2.56,2.56,0,0,1-1.86.86,1.48,1.48,0,0,1-1.67-1.67v-3.69H365v3.44c0,.93.47,1.2,1.18,1.2a2,2,0,0,0,1.54-.79v-3.85h.82v5.23Z"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M370.37,271.25l-.41-.34a1.63,1.63,0,0,0,.7-1l-.15,0a.53.53,0,0,1-.52-.56.58.58,0,0,1,.57-.58.73.73,0,0,1,.69.82A2.09,2.09,0,0,1,370.37,271.25Z"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M380.6,269.87l-4.22-5.76v5.76h-.9v-7.22h.93l4.16,5.64v-5.64h.89v7.22Z"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M382.82,267.25a2.62,2.62,0,0,1,2.58-2.74,2.54,2.54,0,0,1,2.51,2.81v.2h-4.22a1.83,1.83,0,0,0,1.87,1.81,2.29,2.29,0,0,0,1.63-.67l.39.53a2.89,2.89,0,0,1-2.08.81A2.6,2.6,0,0,1,382.82,267.25Zm2.57-2.07a1.73,1.73,0,0,0-1.71,1.73h3.43A1.69,1.69,0,0,0,385.39,265.18Z"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M390,269.08v2.79h-.81v-7.23H390v.78a2.19,2.19,0,0,1,1.77-.91c1.37,0,2.32,1,2.32,2.74s-.95,2.75-2.32,2.75A2.17,2.17,0,0,1,390,269.08Zm3.24-1.83c0-1.16-.63-2-1.68-2a1.91,1.91,0,0,0-1.56.83v2.36a1.93,1.93,0,0,0,1.56.85C392.65,269.28,393.28,268.41,393.28,267.25Z"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M398.7,269.87v-.59A2.27,2.27,0,0,1,397,270a1.74,1.74,0,0,1-1.82-1.73,1.7,1.7,0,0,1,1.82-1.72,2.21,2.21,0,0,1,1.74.7v-.94c0-.7-.57-1.1-1.32-1.1a2.06,2.06,0,0,0-1.61.73l-.38-.56a2.74,2.74,0,0,1,2.09-.87c1.12,0,2,.5,2,1.77v3.59Zm0-1.1v-1a1.79,1.79,0,0,0-1.43-.64,1.15,1.15,0,1,0,0,2.29A1.77,1.77,0,0,0,398.7,268.77Z"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M401.15,269.87v-7.22H402v7.22Z"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M185.73,237v-9.73h6.89v1.82H187.8v2h4.71V233H187.8v2.21h4.82V237Z"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M194.24,237v-9.73h3.83c3.05,0,5.17,1.94,5.17,4.86s-2.12,4.87-5.15,4.87Zm6.88-4.87a2.84,2.84,0,0,0-3-3h-1.78v6.08h1.76A2.91,2.91,0,0,0,201.12,232.14Z"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M204.71,233.11v-5.83h2.1v5.77a2.29,2.29,0,1,0,4.57,0v-5.77h2.11v5.83c0,2.41-1.43,4.07-4.39,4.07S204.71,235.52,204.71,233.11Z"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M215,232.15a4.94,4.94,0,0,1,5.2-5,4.41,4.41,0,0,1,4,2.37l-1.78.88a2.62,2.62,0,0,0-2.27-1.41,3.19,3.19,0,0,0,0,6.38,2.62,2.62,0,0,0,2.27-1.41l1.78.86a4.44,4.44,0,0,1-4,2.39A5,5,0,0,1,215,232.15Z"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M232.07,237l-.62-1.65h-4.17l-.61,1.65h-2.35l3.75-9.73h2.6l3.74,9.73Zm-2.7-7.66-1.52,4.19h3Z"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M236.63,237V229.1h-2.84v-1.82h7.76v1.82h-2.83V237Z"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M242.88,237v-9.73H245V237Z"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M246.41,232.15a5.09,5.09,0,1,1,5.09,5A4.89,4.89,0,0,1,246.41,232.15Zm8,0a3,3,0,1,0-2.95,3.19A2.95,2.95,0,0,0,254.45,232.15Z"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M264.75,237l-4.64-6.35V237H258v-9.73h2.13l4.5,6.11v-6.11h2.07V237Z"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M274.08,233.75a1.73,1.73,0,1,1,1.74-1.72A1.72,1.72,0,0,1,274.08,233.75Z"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M280.93,232.15a4.93,4.93,0,0,1,5.19-5,4.41,4.41,0,0,1,4.05,2.37l-1.78.88a2.61,2.61,0,0,0-2.27-1.41,3.19,3.19,0,0,0,0,6.38,2.61,2.61,0,0,0,2.27-1.41l1.78.86a4.44,4.44,0,0,1-4.05,2.39A4.94,4.94,0,0,1,280.93,232.15Z"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M298,237l-.61-1.65h-4.18l-.61,1.65h-2.35l3.75-9.73h2.6l3.75,9.73Zm-2.7-7.66-1.52,4.19h3Z"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M306.79,237l-1.91-3.46h-1.52V237h-2.07v-9.73h4.55a3,3,0,0,1,3.29,3.13A2.82,2.82,0,0,1,307,233.3l2.21,3.71Zm.21-6.61a1.32,1.32,0,0,0-1.45-1.3h-2.19v2.63h2.19A1.33,1.33,0,0,0,307,230.4Z"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M310.67,237v-9.73h6.89v1.82h-4.81v2h4.71V233h-4.71v2.21h4.81V237Z"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M319.18,237v-9.73h6.89v1.82h-4.82v2H326V233h-4.71v2.21h4.82V237Z"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M333.19,237l-1.92-3.46h-1.51V237h-2.07v-9.73h4.55a3,3,0,0,1,3.28,3.13,2.81,2.81,0,0,1-2.15,2.89l2.21,3.71Zm.2-6.61a1.32,1.32,0,0,0-1.44-1.3h-2.19v2.63H332A1.32,1.32,0,0,0,333.39,230.4Z"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M342.48,233.75a1.73,1.73,0,1,1,1.74-1.72A1.73,1.73,0,0,1,342.48,233.75Z"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M352.52,237l-3.75-9.73h2.35l2.69,7.47,2.7-7.47h2.35L355.11,237Z"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M359.77,237v-9.73h2.07V237Z"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M363.09,235.64l1.14-1.62a4.29,4.29,0,0,0,3.09,1.32c1.16,0,1.7-.51,1.7-1.07,0-1.7-5.6-.52-5.6-4.18,0-1.62,1.4-3,3.69-3a5.41,5.41,0,0,1,3.79,1.36L369.75,230a4.23,4.23,0,0,0-2.83-1.06c-.88,0-1.38.38-1.38,1,0,1.53,5.59.5,5.59,4.13,0,1.78-1.28,3.12-3.89,3.12A5.62,5.62,0,0,1,363.09,235.64Z"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M379.1,237l-.62-1.65h-4.17L373.7,237h-2.35l3.75-9.73h2.6l3.75,9.73Zm-2.7-7.66-1.52,4.19h3Z"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M196.73,172.57l-3.45.49a11.15,11.15,0,0,1-1.7.37c-1.33-.07-2-1.66-3.86-2-.46-.08,0,.07-.68-.23-.91-.38.22-.11-.88-.41,0,1.2-.26.86-.26,1.81a6.89,6.89,0,0,0,.76,3.13c.34.68.49.45.45,1.43,0,1.85-.26,2.38.53,3.93.42.87,1.25,1.81,1.36,2.79,1.82,0,1.56-.08,1.78.53,1.71,0,.61-.38,1.56-.53.07,0,1.74.41,1.28-1.77,1.29.34.68,1,1.52.94.68-.08.34-.64.45-1.44s-.34-.22.87-.79l-.26-1.54c0-1.82.41,0,1,.26l.76-5.43c.07-.42.56-.23-.49-1.78C196.31,172.45,197,172.49,196.73,172.57Z"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M197.22,168c-.19.72.42.42-.49.49l1,2.31c.45-.23.3-.19,1-.23,0-1.59,0-1-.53-1.81C197.9,168.26,197.9,168.11,197.22,168Z"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M184.35,165.89c-.27,1.05-.08,0-.34.83-.42,1.24-.46,2.3,1.09,1.47C185.1,166.38,185.29,166.53,184.35,165.89Z"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M164.51,147.66a9.49,9.49,0,0,0-3.14.49c-1.9.49-1.06.91-.46,1.81,3.6,0,2.42-.3,4.47-.64.83-.15.91.11.42-.9h-1.29Z"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M216.64,135a6.59,6.59,0,0,0-.24-.87l-2.93-1.09c-2.1-.78-4.19-1.55-6.23-2.37-1.81-.74-4.2-1.72-6.55-2.89s-5-2.52-7.6-4.13a17.38,17.38,0,0,1-6.25-7.09,22.11,22.11,0,0,1-1.4-3.57l-.5,0a13.16,13.16,0,0,0-2.83.38c-.89.2-1.78.44-2.67.67a33.24,33.24,0,0,1-7.18,1.36l-.94.06c-.91,0-1.82.11-2.72.11a18.34,18.34,0,0,1-2-.11,38.89,38.89,0,0,1-4.31-.78l-1.52-.32c-.37.46-.76.92-1.16,1.37a3.86,3.86,0,0,1,.78.73,5.17,5.17,0,0,1,1.08,5,7.76,7.76,0,0,1-6.72,4.94c-.85,0-1.65,0-2.45-.1l-.42,0c-2.7-.15-4.93-1.61-6.62-4.33-1.79-2.89-.08-5.57.48-6.45l.13-.2c.33-.54.7-1.07,1.07-1.6a17.64,17.64,0,0,0,1.21-1.88l.66-1.37a8.8,8.8,0,0,1-7.42-5.6,18.17,18.17,0,0,1-1.14-5.37l-.74.2-1.18.29a12.17,12.17,0,0,1-1,1.12,6.51,6.51,0,0,1-4.58,2.14,6.09,6.09,0,0,1-1.81-.28h-.29a5.89,5.89,0,0,1-3.41-1.06,4.31,4.31,0,0,1-1.94-1.34,4.47,4.47,0,0,1-.86-3.83,16.2,16.2,0,0,1,2.94-6.38l.36-.5a6,6,0,0,1,1.79-3.64c.78-.78,1.57-1.45,2.34-2.1l.62-.53a14.57,14.57,0,0,1,1.29-1A7.85,7.85,0,0,1,135,79.18a14.23,14.23,0,0,1,4.25-4.13c.88-.58,1.77-1.06,2.62-1.53.5-.27.9-.5,1.3-.73s.79-.48,1.19-.73l.68-.42a3.84,3.84,0,0,1,2-.59,3.9,3.9,0,0,1,1.65.37,4,4,0,0,1,2.23,4.65s-1,3.39-1.31,4.49a10.32,10.32,0,0,1-1.88,3.57c.83.52,1.81,1.16,2.77,1.9a17.59,17.59,0,0,1,2.2,2.06h1.67A3.77,3.77,0,0,0,155,88,14.66,14.66,0,0,0,159,86.13l.58-.35a35.75,35.75,0,0,1,8-3.82,55,55,0,0,1,14.24-2l1.88,0c2.64,0,5.28.13,7.73.28a45.32,45.32,0,0,1,5.91.79,34.47,34.47,0,0,1,14.23,6.18,2.65,2.65,0,0,0-1.4-2c-.76-.34-.38.08-.91-.45,0,0-.08-.08-.12-.12l-.56-.45c-.91-.56-.76.15-1.1-1.24l-.34.18a.44.44,0,0,0-.15.08c-.57.15-.38-1-.91-1.66s.23.49-1.1-.19c-.72-.34,0,0-.42-.3a1.15,1.15,0,0,0-.53-.27l-.45-.11c-2.12-.87-1.74-1.21-1.74-3.36-1.82-.49-.72-1.88-.61-3,.23-1.89-.91-2.12-.45-4.15-2.54,0-1.52-2.53-2.24-5.25l-.11-2.49c.11-.53,0,.23.3-.72l-.68-.34c-2.42-1.43-1.93-2.56-2.65-3l-1.78.56c-.53.38,0,.26-.79.45-1.71-1.58-.91-4.9-1.48-7-.23-.9-.42-2.15-1.63-2.45a4,4,0,0,1,.76-1.55c-.61-.3-.91-.22-1.52-.52a7.38,7.38,0,0,0-.79-4.12c-.49-.83-.15-.9-1.29-1-.3,1.21-.19.49-1.29,1a7.25,7.25,0,0,1-.94,4s-.08.11-.08.15l-.23.3a5.16,5.16,0,0,0-1.06,2.53h.76c-.07,1.17-.07.49-.57,1.2-.68,1-.3-.07-.15,1.29s-.91,1.43-.79,2.86c.07.95.41.65.38,1.55,0,.53-.27.76-.23,1.47.07,1.93.79,1.44-.08,3.29S182.08,66,180.9,68a24.06,24.06,0,0,0-1.32,2.8,3.77,3.77,0,0,1-2.92,1.13,12.1,12.1,0,0,1-2.61-1.28c-.49-.27-.87-.42-1.1-.91s-.07-.34-.3-.75c-.61-1.29-2.31-1.17-3.52-1.63s-1.67-2.19-4.62-3.35l-1.55-.5s-1.14-.75-1.22-.83l-1-1.09c-.3-.26-.83-.57-1.21-.87l-1.1-.68c-1-.56-.87,0-.91-1.43.57-.19,1.21-1.25,1.7-1.93.31-.37.08,0,.31-.45l.23-.56s0-.12.07-.16c.15-.37.38-.94.53-1.28-1.06-.41,0,.19-1-.26.42-.61.3-.27.53-1,1.32-.64,1-.27,1.78,0,1.55-2.27.64-.83,1-2.15.31-1.1,1.06-1.36,1.59-2.19l-.94-.6c-1.06-.57-.84.41-.84-1.48A4.88,4.88,0,0,0,160.38,48c-.26-.34-.26.53-.26-.75a4.08,4.08,0,0,1-1.29.49c.76-1,.41,0,.79-1-1.74.41-2.38.45-3.37,1.28-.64-.45-1-.41-1.28-1.28-1.29.11-.34.19-1.52.53a5.92,5.92,0,0,0-2.08-1.06v-.49c-1.36.11-2.27.87-3.45-.45-.07-.08-.56-.95-.68-1.1-.94.27-.53.27-1.28.76a2,2,0,0,0-1.14-1.44c-.42-.26-.11-.11-.53-.19l-1.44.12c-.19.07.38.11-.76.22v.8c1,.22.08,0,.72.3l.19.11s.08.08.15.08c.76.34.84,0,2,0a5.86,5.86,0,0,1,.49,2.34l-1.89.64a.29.29,0,0,1-.15.07l-2.31.27c-1-.12-.65-.23-1-1-.18.07-.45.22-.68.34L139,48c-.76.57.38.23-.87.68a2.41,2.41,0,0,1-1.18.11c0,.68,0,.65-.56,1.48s0,.75-1.25.87c0,1.84.19.79.53,2l-.84.3c-1.28.31-.68.31-1.13,1.59s-1.1.38-1.63,2.75c.83.57,1,.57,1.17,1.1a1.92,1.92,0,0,1,.12.94c-2.46-.19-1.36.15-2.27-.07a9.45,9.45,0,0,0-2.88-.46c0,1.89-.08.61-.53,1.1l-.11.11-.38.6c0-1.77.38-.52.49-2-2.16-.61-2.08-2.91-4.28-3.29-1.78-.34,0-.52-1.89-.56-.46.94-.19,1.13-1,1.77.26-1.21.15-.38,0-.75-1,.22-.57.26-1.29.75-.15-1.17-.3-1-1.29-.49.19.76,0,.53.76.76a2.93,2.93,0,0,0-.53,1.54l-1.52-1.28c-.68,1.32.16.87-1,1.58l-.34.19c-.34.19-.42.31-.76.53.38,1.4.68.27.27,1.28-.87.12-1,.38-1.56,1.17,0,0-.07.08-.11.08a1.16,1.16,0,0,1-.19.23c-.11.11-.3.26-.42.37-.37.34-.83.49-.94,1.29a2.26,2.26,0,0,0,.64,1.47c-.57.68-.49.45-.53,1.55l-1.13-.38c-1.18-.27-.57.64-.91-.38h-1.29c0,1.74-.64,1.32-.26,2.08.26.49.94.64,1.55,1.51-.65.26-.23.18-1,0,.12,1.35.31.45,0,1.81-.79-.57-.37-.42-1.28-2.08s-1-.56-.8-2.3c-1.06.3-1,.83-1.51,1.55l-1.25,1.32a4.38,4.38,0,0,0-1,2c0,.75.45,1.16.45,2.52.17.1.12.16.09.18A4.4,4.4,0,0,1,104,75c-.15.57,0,.31-.38.68l-.23.27c-.38.41-.15.15-.41.37l-.42.34-.15.12-.31.22c-.64.53-.49.61-.79,1.29l-.11.34c-1.56,4.07-2.5,4.07-7.08,5.81-.87.3,0,.19-1,.26-1.25.11-.68-.6-1.74.11s-.19.61-1,1.29c-1.29,1-1.48-.42-3.9,2a2.11,2.11,0,0,1-1.59.64c-1.33,0-.34-.76-2,.37-.11-1.35.27-.49-.49-.79-.23.83-.19.68-.87,1.21-1.55,1.17-.3-.34-2.54,2.11l-.26.27-.8,1s-.15.22-.23.3c-1.21,1.36-3.82.79-3.82,4.91h-.76a18.65,18.65,0,0,1-.26-2.84c-1.33.87-1.78,3.1-1.82,4.61.83.3.23-.42.68.64a3.55,3.55,0,0,1-.19,3.17,4.34,4.34,0,0,0-.49,1.4V107c.08.6.23.41.83,1.13.72.94.19.94,1.33,2.26a1.43,1.43,0,0,0,.15.11c.3.38.34.49.64.91,1,1.32,1.44.64,1.44,3.7h-.53A4.13,4.13,0,0,0,72,111.7c0,2.38.65.79.8,2.57-.61-.38-.27-.31-1-.5-.12,1.33.22.46-.53.76,1.66,2.49,4.27,3.43,4.92,6.64.26,1.43,1.78,2.19,2.31,3.4.3.68-.12.15.41.83.27.3.5.45.8.75a3.68,3.68,0,0,1,.87,2.23c.87,5.43,4.17,6.56,4.51,9.81l0,1.92c-.19,1.14.15.95.42,2.08s-.15,1.51-.38,2.38a5.85,5.85,0,0,1-1.51-.23c0,1.85-.08,3.55,1.59,3.51,2.15,0,2.91,2.64,6.47,2,1.1-.19,3,.07,3.94-.49s1.13-1.21,1.51-1.63l.12-.11.38-.41.22-.27.76-.45c.61-.08,1.55,0,1.82-.91,0,0,0-.41,0-.49.37-1.43,2.42-1.39,3.74-1.85l3-.41c.22,0,.3,0,.6,0,.95-.08-.26-.15.68-.15l.38.11s.08,0,.12.07c.9.42-.69.23.94.34.23-.56.53-.86,2.16-.83,1.1,0,3,.8,3.82-2.68a2.56,2.56,0,0,1,.5-1.32c.64-.75,1.06-.41,2.08-1,4.09-2.37,2.5-2.79,7.15-2.86a13.76,13.76,0,0,0,4.93-1.51c3-1.21,2.72-2.08,7.42-2.08a12.14,12.14,0,0,0,2.95-.41c1.14-.19,3.41,1.62,4.28,2.19,1.48-.38.68-1.06,2.5.07,1.1.64,1.85.42,3.14.72.34.79.11,0,0,1.28.83-.19.83-.34,1.55,0-.23.57-.49.38-.64.95l.53,1.47c.64.56,1.13,0,1.78.79.53.64.41,1.09,1.36,2.26a4.14,4.14,0,0,1,.83,2.49s-.11,0-.11,0-.11,0-.11,0-.12,0-.15,0l-.65.68c1.55.15,1.14,1.13,2.54,1.47.49.07,0,0,.53.11,0,0,.07.12.53.23l-.19-1c-.19-.79.11-1,1.51-2.79.95-1.21,2.73-1.21,3.45-2.53a6.62,6.62,0,0,1,1.13-1.92c.65-.68.19.26.57-.72.15.16.13.12.12.11l.22.3a4.21,4.21,0,0,1,.42.61c-.76.07-.64.11-1,.49.53,1.17.57,1,0,1.73a6.08,6.08,0,0,0-1.29,4c0,1.51-.34,1.17-1.78,1.17-.22.94-.41.72-.53,1.81a5.58,5.58,0,0,0,1.82-.53c1.1-.26,1.21.61,1.82-.75l1-3.1.49.8c0,.07,0,.15.08.19l.19.34a.23.23,0,0,1,.07.15c1.44,2.9-.94,3-1.09,4.68a8.26,8.26,0,0,0,2.57-.5s.11,0,.15.12.12.07.15.11c1.59,1.36,3.3,3.13,2.58,5.47,0,0,0,.12,0,.15l-.08,1.29a4.26,4.26,0,0,0,1.1,1.62l1.06,1.74c.8.86,2,.49,2.88,1.5l.72.84c.75-.27.75-.57,1.55-.34l.57.22c.07,0,.15,0,.23.08.68.19.34,0,1,.3s2.61,1.47,2.84,2c1.44-.12,4.2-3.66,4.88-1,1.29-.12,1.33-.91,2.35-1l-.19.34c-.34.75-.19-.45-.34.94l1.21,1.1.38.37.8.31a2.07,2.07,0,0,1,.45,1,1.26,1.26,0,0,0,.76-1.81c3,0,3.9-3,7.12-2.9,2.08.11,3.71.71,5.22-.5l.53-.71c.38-.91,0-1.13.15-1.93l1.37-3.73c1.06-2.79,2.08-2.83,2.72-3.32s.19-.19.27-.68v-.19l.15-.68a5.21,5.21,0,0,1,1.4-2.45c1.51-1.25.87-2.12,3.14-4.57l1.48-.83a.34.34,0,0,1,.19-.07l.52-.39C217.3,138.59,217,136.81,216.64,135Z"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M103.3,75.16Z"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M150.75,91.65a29.78,29.78,0,0,0-2.61-2.56,40.27,40.27,0,0,0-4-2.58,7.66,7.66,0,0,0-2-.76,3.32,3.32,0,0,0-1.26,0,8.6,8.6,0,0,1,2.15-2.43,7.62,7.62,0,0,0,2.83-3.81c.44-1.49.87-3,1.3-4.48l-.15-.07c-.66.41-1.3.83-2,1.22-1.25.72-2.55,1.37-3.76,2.15a10.38,10.38,0,0,0-3.11,3,4.35,4.35,0,0,0-.61,3.13c.06.76-.36.77-.36.77A5.18,5.18,0,0,0,135,86.55c-.93.79-1.89,1.57-2.75,2.43a2.31,2.31,0,0,0-.69,1.38,4.23,4.23,0,0,1-1.07,2.31,12.43,12.43,0,0,0-2.28,4.88c-.12.61.15.86.82.74a1.87,1.87,0,0,0,2.08.79c.1,0,.22-.09.29-.06,1.33.65,2,.54,3.2-.66a6.24,6.24,0,0,0,.86-1c.62-.92,1.64-1,2.57-1.26a7.6,7.6,0,0,0,3.17-1.27s.71-.6,1-.16a8.18,8.18,0,0,1,1.26,1.66,7.48,7.48,0,0,1,.6,2.43,15.42,15.42,0,0,0,.9,4.7,5.07,5.07,0,0,0,5.88,3.11,9.77,9.77,0,0,1,5.09.07c.32.11.62.27,1,.43L155,106.9a.54.54,0,0,0-.63.41c-.9,2.12-1.76,4.26-2.8,6.31-.68,1.33-1.65,2.5-2.45,3.77-.48.78-1.17,1.66-.6,2.57a4.5,4.5,0,0,0,3.55,2.51c.88,0,1.75.11,2.63.12a4,4,0,0,0,3-2.23,1.46,1.46,0,0,0-.38-1.45,1.32,1.32,0,0,1-1.33.82,3.14,3.14,0,0,0-.85.37c0-.57.55-.56,1-.72l-.15-1.11c-.17.1-.25.12-.3.18A1.22,1.22,0,0,1,154,119l-.71-.22c-.76-.23-.9-.15-1,.6,0,.16,0,.32,0,.57a1.56,1.56,0,0,1,.16-2c1-1.2,1.93-2.39,3-3.49a40.45,40.45,0,0,0,6-8,4.81,4.81,0,0,0,.56-1.49,2.92,2.92,0,0,0-1.39-3A28.25,28.25,0,0,0,157,99.7a2.5,2.5,0,0,1-1.56-3l.31,1c.29.92,1.15,1.19,1.88,1.58,1.16.62,2.38,1.15,3.53,1.8,2.49,1.42,2.59,3.48,1.14,5.7-.65,1-1.24,2-1.85,3-.22.37-.23.6.33.7,2.07.38,4.1,1,6.18,1.19a31.83,31.83,0,0,0,5.07-.08c3.18-.17,6.16-1.27,9.22-2a14,14,0,0,1,5.43-.32,1.33,1.33,0,0,0,.38,0c-.11-1-.22-1.94-.32-2.9-.08-.8-.15-1.6-.23-2.4-.28-2.71-.53-5.42-1.9-7.86-.24-.41-.53-.78-.83-1.23a4.84,4.84,0,0,1,1.77,1.58,9.32,9.32,0,0,1,1.44,3.9c.46,2.36.75,4.74,1.16,7.11a26,26,0,0,0,2.14,7.42,13.47,13.47,0,0,0,4.84,5.54,82.22,82.22,0,0,0,7.27,4c2.05,1,4.16,1.92,6.28,2.77,2.63,1.06,5.29,2,8,3,1.27.47,2.56.91,3.83,1.39A2.32,2.32,0,0,1,222,133l-2.1-1.07-.1.16c.22.73.48,1.46.63,2.21.39,2,.75,4,1.1,6,.27,1.56.53,3.12.73,4.69.12.86.1,1.74.15,2.61a5.48,5.48,0,0,0,1.22,3.6,9.58,9.58,0,0,0,.82.75,27.24,27.24,0,0,1,4.47,5.52,4.6,4.6,0,0,0,1.55,1.43h1.26c0-.13,0-.28-.06-.37a1.5,1.5,0,0,1-.15-2,5.25,5.25,0,0,0,.58-1.41c.18-.84-.41-1.43-.83-2.05-.15-.22-.33-.41-.51-.63l-1,1.36-.16-.06A2.39,2.39,0,0,0,230,151a4.34,4.34,0,0,0-1.71-2.35c-1.44-.75-1.79-2.09-2-3.47-.29-1.79-.45-3.6-.64-5.41a21,21,0,0,1-.24-3.16c.06-1.52.33-3,.43-4.56a3.37,3.37,0,0,0-.91-2.47,21.35,21.35,0,0,0-4.2-3.13c-2.65-1.83-5.33-3.65-7.85-5.65a36.57,36.57,0,0,1-8.61-9.85,11.65,11.65,0,0,1-1.46-4.42,7.41,7.41,0,0,1,.48-3.67c0,2.17,0,4.36.88,6.42,1.37-.36,2.63-.88,2.85-2.4a9.14,9.14,0,0,0-.19-2.75c-.14-.85.3-1.34,1.15-1.16a4.32,4.32,0,0,1,2.65,2c2.13,3.14,4.14,6.35,6.2,9.54,1.25,1.94,2.47,3.9,3.77,5.81,1.74,2.55,3.51,5.08,5.35,7.56a48.53,48.53,0,0,0,3.25,3.77c1,1.1,2.1,2.14,3.18,3.18a41.36,41.36,0,0,0,16.79,9.55,63.55,63.55,0,0,0,7.34,1.59,32.58,32.58,0,0,0,6.16.37,43.59,43.59,0,0,0,6.53-.78,36.45,36.45,0,0,0,9.72-3.34c1.5-.76,2.9-1.72,4.34-2.6a.61.61,0,0,0,.26-.27c.06-.33.09-.66.13-1a2.21,2.21,0,0,0-.83-.08c-.77.28-1.53.62-2.28,1a45,45,0,0,1-8.28,3,39,39,0,0,1-5.74,1.09,46.83,46.83,0,0,1-6.38,0,26.89,26.89,0,0,1-10.93-3.13,32.51,32.51,0,0,1-7.35-5.12c-.83-.76-1.66-1.53-2.46-2.32a54.94,54.94,0,0,1-5.82-7.1,102.7,102.7,0,0,1-6.16-10.15c-1.39-2.52-2.73-5.06-4.12-7.58a72.75,72.75,0,0,0-6.69-10.51,45.49,45.49,0,0,0-5.28-5.64,30.33,30.33,0,0,0-14.63-7.07,41,41,0,0,0-5.39-.73c-3.09-.18-6.2-.33-9.29-.25a51.21,51.21,0,0,0-13.24,1.85A35.06,35.06,0,0,0,161,89.46a17.83,17.83,0,0,1-5.22,2.31,6.72,6.72,0,0,1-1.41.18,26.52,26.52,0,0,0-3.09.11Z"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M488.59,51h-2.08v5.87H485.3V51h-2.09V49.73h5.38Z"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M496.19,49.73v7.09H495v-5l-2.34,3.61-2.32-3.61v5h-1.22V49.73h1.33l2.21,3.44,2.23-3.44Z"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M301.85,68.11v2.28a16.28,16.28,0,0,0-4-2.16,14.8,14.8,0,0,0-5.22-.86,15.64,15.64,0,0,0-6.1,1.17,14.76,14.76,0,0,0-4.83,3.22,15.15,15.15,0,0,0,0,21.28,14.76,14.76,0,0,0,4.83,3.22,15.64,15.64,0,0,0,6.1,1.17l.28,0,.32,0a16.29,16.29,0,0,0,6.15-1.16V88.16l0,0A8.29,8.29,0,0,1,296.5,90a9.11,9.11,0,0,1-3.3.6,9.23,9.23,0,0,1-1.4-.11h0a8.54,8.54,0,0,1-1.93-.49,7.59,7.59,0,0,1-2.8-1.79,7.91,7.91,0,0,1,0-11.58,8.55,8.55,0,0,1,2.8-1.77,9,9,0,0,1,3.33-.63,8.55,8.55,0,0,1,6.12,2.4,7.75,7.75,0,0,1,2.53,5.82v15h7.2V68.11Z"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M271.34,97.43,255.36,82V97.43h-7.2V56.82h7.2V72.17l16-15.29h10.21L260.47,77.09l21.08,20.34Z"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M327.79,67.37a13.1,13.1,0,0,1,5.35,1.06,12.21,12.21,0,0,1,4.11,2.9,13.28,13.28,0,0,1,2.64,4.31,14.72,14.72,0,0,1,.93,5.25V97.43h-7.2V80.89a6.12,6.12,0,0,0-2.11-4.74,6.9,6.9,0,0,0-4.92-1.94,7,7,0,0,0-5,1.94,6.29,6.29,0,0,0-2.05,4.74V97.43h-7.2V68.17h7.2v2.17a14.2,14.2,0,0,1,3.67-2.14A12.06,12.06,0,0,1,327.79,67.37Z"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M425.47,68.17a12.89,12.89,0,0,1,4.84-.86v6.85a8.59,8.59,0,0,0-6.13,2.39,8,8,0,0,0-2.52,5.82V97.43h-7.21V68.11h7.21v2.23A15.41,15.41,0,0,1,425.47,68.17Z"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M446.61,67.37a16.35,16.35,0,0,1,6.19,1.17,15.92,15.92,0,0,1,5,3.22,15.13,15.13,0,0,1,3.39,4.79,14.42,14.42,0,0,1,0,11.7A15.13,15.13,0,0,1,457.84,93a15.92,15.92,0,0,1-5,3.22,17,17,0,0,1-12.38,0,15.92,15.92,0,0,1-5-3.22A15.13,15.13,0,0,1,432,88.25a14.07,14.07,0,0,1-1.23-5.82A14.21,14.21,0,0,1,432,76.55a15.13,15.13,0,0,1,3.39-4.79,15.92,15.92,0,0,1,5-3.22A16.35,16.35,0,0,1,446.61,67.37Zm0,6.84a8.55,8.55,0,0,0-6.12,2.4,7.89,7.89,0,0,0,0,11.58A7.55,7.55,0,0,0,443.28,90a9.35,9.35,0,0,0,3.33.6,9.11,9.11,0,0,0,3.3-.6,8.42,8.42,0,0,0,2.83-1.79,7.91,7.91,0,0,0,0-11.58A8.86,8.86,0,0,0,446.61,74.21Z"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M480.33,67.37a16.31,16.31,0,0,1,6.19,1.17,15.92,15.92,0,0,1,5,3.22,15.16,15.16,0,0,1,3.4,4.79,14.21,14.21,0,0,1,1.23,5.88A14.07,14.07,0,0,1,495,88.25a15.16,15.16,0,0,1-3.4,4.79,15.92,15.92,0,0,1-5,3.22,16.93,16.93,0,0,1-12.37,0,16,16,0,0,1-5-3.22,15.13,15.13,0,0,1-3.39-4.79,14.07,14.07,0,0,1-1.23-5.82,14.21,14.21,0,0,1,1.23-5.88,15.13,15.13,0,0,1,3.39-4.79,16,16,0,0,1,5-3.22A16.26,16.26,0,0,1,480.33,67.37Zm0,6.84a8.55,8.55,0,0,0-6.12,2.4,7.91,7.91,0,0,0,0,11.58A7.64,7.64,0,0,0,477,90a9.35,9.35,0,0,0,3.33.6,9.11,9.11,0,0,0,3.3-.6,8.23,8.23,0,0,0,2.83-1.79,7.91,7.91,0,0,0,0-11.58A8.84,8.84,0,0,0,480.33,74.21Z"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M403.26,68.11v2.28a16,16,0,0,0-4-2.16,14.9,14.9,0,0,0-5.23-.86,15.68,15.68,0,0,0-6.1,1.17,14.66,14.66,0,0,0-8,8,15.18,15.18,0,0,0-1.14,5.88,15,15,0,0,0,1.14,5.82,14.66,14.66,0,0,0,8,8,15.68,15.68,0,0,0,6.1,1.17l.28,0,.32,0a16.29,16.29,0,0,0,6.15-1.16V88.16l0,0A8.33,8.33,0,0,1,397.91,90a9.11,9.11,0,0,1-3.3.6,9.33,9.33,0,0,1-1.4-.11h0a8.68,8.68,0,0,1-1.93-.49,7.55,7.55,0,0,1-2.79-1.79,7.89,7.89,0,0,1,0-11.58,8.51,8.51,0,0,1,2.79-1.77,9,9,0,0,1,3.33-.63,8.59,8.59,0,0,1,6.13,2.4,7.74,7.74,0,0,1,2.52,5.82v15h7.21V68.11Z"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M368.33,68.11v2.28a16.11,16.11,0,0,0-4-2.16,12.22,12.22,0,0,0-2.6-.66,17.91,17.91,0,0,0-3.1-.26,15,15,0,0,0-6,1.17,14,14,0,0,0-4.68,3.23,14.68,14.68,0,0,0-3,4.79,15.82,15.82,0,0,0-1.08,5.87v.06A14.86,14.86,0,0,0,348.15,93,14.76,14.76,0,0,0,353,96.26a15.64,15.64,0,0,0,6.1,1.17l.28,0,.32,0h.12l.34,0a16.12,16.12,0,0,0,5.69-1.14V88.16l0,0A8.29,8.29,0,0,1,363,90a9.11,9.11,0,0,1-3.3.6,9.23,9.23,0,0,1-1.4-.11h0a8.54,8.54,0,0,1-1.93-.49,7.59,7.59,0,0,1-2.8-1.79A7.75,7.75,0,0,1,351,82.4a8.14,8.14,0,0,1,.59-3l.11-.24a8.09,8.09,0,0,1,1.82-2.52,8.55,8.55,0,0,1,2.8-1.77,9,9,0,0,1,3.33-.63,8.55,8.55,0,0,1,6.12,2.4,8,8,0,0,1,1.83,2.52l.11.24a7.91,7.91,0,0,1,.59,3.06v11.4a7.62,7.62,0,0,1-2.53,5.76,8.81,8.81,0,0,1-10.44,1.32l-5.23,4.9a16,16,0,0,0,4.45,2.28,16.61,16.61,0,0,0,11.29-.4,16.17,16.17,0,0,0,5-3.25,14.91,14.91,0,0,0,3.39-4.79,14,14,0,0,0,1.24-5.82V68.11Z"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M256.53,122.22v1.92h-8.37V113.23h8v1.92h-5.89v2.77h4.94v1.86h-4.94v2.44Z"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M270.35,112.33V124h-2.17v-.51a4.93,4.93,0,0,1-2.44.65,4.35,4.35,0,0,1,0-8.7,5,5,0,0,1,2.44.64v-3.75Zm-2.17,9.13v-3.37a3.18,3.18,0,0,0-2.05-.71,2.4,2.4,0,0,0-2.51,2.41,2.36,2.36,0,0,0,2.51,2.4A3.12,3.12,0,0,0,268.18,121.46Z"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M284.1,115.61V124h-2.16v-.56a4,4,0,0,1-2.29.68c-2.46,0-3.59-1.14-3.59-3.87v-4.66h2.15v4.66c0,1.3.64,1.94,1.83,1.94a2.85,2.85,0,0,0,1.9-.67v-5.93Z"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M297.34,122.45a4,4,0,0,1-3.25,1.69,4.35,4.35,0,1,1,0-8.68,4.08,4.08,0,0,1,3.29,1.67l-1.4,1.28a2.3,2.3,0,0,0-1.89-1,2.41,2.41,0,1,0,0,4.82,2.27,2.27,0,0,0,1.89-1Z"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M311.14,115.61V124H309v-.62a4.41,4.41,0,0,1-2.46.74,4.35,4.35,0,0,1,0-8.7,4.89,4.89,0,0,1,2.46.7v-.53ZM309,118.12a3.2,3.2,0,0,0-2.07-.73,2.41,2.41,0,1,0,0,4.82,3.15,3.15,0,0,0,2.07-.72Z"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M319.57,117.39v3c0,1.51.25,1.94,1.33,1.94a9,9,0,0,0,1-.08v1.61a5.27,5.27,0,0,1-1.95.31,2.42,2.42,0,0,1-2.54-2.65v-4.1h-1.19v-1.78h1.19v-3.26h2.17v3.26h2.35v1.78Z"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M327.06,113.57a1.26,1.26,0,0,1,1.24-1.27,1.24,1.24,0,0,1,1.22,1.27,1.23,1.23,0,0,1-1.22,1.25A1.24,1.24,0,0,1,327.06,113.57Zm.17,2.17h2.15v8.4h-2.15Z"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M344,119.81a4.61,4.61,0,1,1-4.6-4.35A4.47,4.47,0,0,1,344,119.81Zm-2.12,0a2.48,2.48,0,1,0-2.48,2.4A2.45,2.45,0,0,0,341.91,119.81Z"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M357.43,119.45v4.69h-2.15v-4.69c0-1.3-.64-1.93-1.83-1.93a2.74,2.74,0,0,0-1.86.66v6h-2.15v-8.4h2.15v.52a3.94,3.94,0,0,1,2.25-.68C356.3,115.58,357.43,116.73,357.43,119.45Z"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M374.32,115.15V119h5.21V121h-5.21v3.19h-2.16V113.23h8.22v1.92Z"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M394.28,119.81a4.6,4.6,0,1,1-4.59-4.35A4.46,4.46,0,0,1,394.28,119.81Zm-2.12,0a2.48,2.48,0,1,0-2.47,2.4A2.45,2.45,0,0,0,392.16,119.81Z"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M407.64,115.61V124h-2.15v-.56a4.09,4.09,0,0,1-2.29.68c-2.46,0-3.59-1.14-3.59-3.87v-4.66h2.15v4.66c0,1.3.63,1.94,1.82,1.94a2.88,2.88,0,0,0,1.91-.67v-5.93Z"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M421.45,119.45v4.69h-2.16v-4.69c0-1.3-.63-1.93-1.82-1.93a2.74,2.74,0,0,0-1.86.66v6h-2.15v-8.4h2.15v.52a3.91,3.91,0,0,1,2.24-.68C420.32,115.58,421.45,116.73,421.45,119.45Z"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M435.65,112.33V124h-2.16v-.51a5,5,0,0,1-2.45.65,4.35,4.35,0,0,1,0-8.7,5.07,5.07,0,0,1,2.45.64v-3.75Zm-2.16,9.13v-3.37a3.21,3.21,0,0,0-2.06-.71,2.4,2.4,0,0,0-2.51,2.41,2.36,2.36,0,0,0,2.51,2.4A3.15,3.15,0,0,0,433.49,121.46Z"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M449.89,115.61V124h-2.15v-.62a4.41,4.41,0,0,1-2.46.74,4.35,4.35,0,0,1,0-8.7,4.92,4.92,0,0,1,2.46.7v-.53Zm-2.15,2.51a3.2,3.2,0,0,0-2.07-.73,2.41,2.41,0,1,0,0,4.82,3.15,3.15,0,0,0,2.07-.72Z"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M458.33,117.39v3c0,1.51.25,1.94,1.33,1.94a9,9,0,0,0,1-.08v1.61a5.27,5.27,0,0,1-1.95.31,2.42,2.42,0,0,1-2.54-2.65v-4.1H455v-1.78h1.19v-3.26h2.17v3.26h2.35v1.78Z"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M465.82,113.57a1.26,1.26,0,0,1,1.24-1.27,1.24,1.24,0,0,1,1.22,1.27,1.23,1.23,0,0,1-1.22,1.25A1.24,1.24,0,0,1,465.82,113.57Zm.17,2.17h2.15v8.4H466Z"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M482.78,119.81a4.6,4.6,0,1,1-4.59-4.35A4.46,4.46,0,0,1,482.78,119.81Zm-2.12,0a2.48,2.48,0,1,0-2.47,2.4A2.44,2.44,0,0,0,480.66,119.81Z"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M496.19,119.45v4.69H494v-4.69c0-1.3-.64-1.93-1.83-1.93a2.74,2.74,0,0,0-1.86.66v6H488.2v-8.4h2.15v.52a3.94,3.94,0,0,1,2.25-.68C495.06,115.58,496.19,116.73,496.19,119.45Z"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "cls-8",
    x1: 0.13,
    y1: 0.13,
    x2: 567.05,
    y2: 0.13
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "cls-8",
    x1: 0.12,
    y1: 283.59,
    x2: 567.05,
    y2: 283.59
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    className: "cls-8",
    x1: 0.13,
    y1: 0.13,
    x2: 0.13,
    y2: 283.59
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    className: "cls-8",
    x1: 283.59,
    y1: 0.13,
    x2: 283.59,
    y2: 283.59
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    className: "cls-8",
    x1: 28.47,
    y1: 0.13,
    x2: 28.47,
    y2: 283.59
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    className: "cls-8",
    x1: 56.82,
    y1: 0.13,
    x2: 56.82,
    y2: 283.59
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    className: "cls-8",
    x1: 85.16,
    y1: 0.13,
    x2: 85.16,
    y2: 283.59
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    className: "cls-8",
    x1: 113.51,
    y1: 0.13,
    x2: 113.51,
    y2: 283.59
  })), _line9 || (_line9 = /*#__PURE__*/React.createElement("line", {
    className: "cls-8",
    x1: 141.86,
    y1: 0.13,
    x2: 141.86,
    y2: 283.59
  })), _line0 || (_line0 = /*#__PURE__*/React.createElement("line", {
    className: "cls-8",
    x1: 170.2,
    y1: 0.13,
    x2: 170.2,
    y2: 283.59
  })), _line1 || (_line1 = /*#__PURE__*/React.createElement("line", {
    className: "cls-8",
    x1: 198.55,
    y1: 0.13,
    x2: 198.55,
    y2: 283.59
  })), _line10 || (_line10 = /*#__PURE__*/React.createElement("line", {
    className: "cls-8",
    x1: 226.9,
    y1: 0.13,
    x2: 226.9,
    y2: 283.59
  })), _line11 || (_line11 = /*#__PURE__*/React.createElement("line", {
    className: "cls-8",
    x1: 255.24,
    y1: 0.13,
    x2: 255.24,
    y2: 283.59
  })), _line12 || (_line12 = /*#__PURE__*/React.createElement("line", {
    className: "cls-8",
    x1: 14.3,
    y1: 0.13,
    x2: 14.3,
    y2: 283.59
  })), _line13 || (_line13 = /*#__PURE__*/React.createElement("line", {
    className: "cls-8",
    x1: 42.64,
    y1: 0.13,
    x2: 42.64,
    y2: 283.59
  })), _line14 || (_line14 = /*#__PURE__*/React.createElement("line", {
    className: "cls-8",
    x1: 70.99,
    y1: 0.13,
    x2: 70.99,
    y2: 283.59
  })), _line15 || (_line15 = /*#__PURE__*/React.createElement("line", {
    className: "cls-8",
    x1: 99.34,
    y1: 0.13,
    x2: 99.34,
    y2: 283.59
  })), _line16 || (_line16 = /*#__PURE__*/React.createElement("line", {
    className: "cls-8",
    x1: 127.68,
    y1: 0.13,
    x2: 127.68,
    y2: 283.59
  })), _line17 || (_line17 = /*#__PURE__*/React.createElement("line", {
    className: "cls-8",
    x1: 156.03,
    y1: 0.13,
    x2: 156.03,
    y2: 283.59
  })), _line18 || (_line18 = /*#__PURE__*/React.createElement("line", {
    className: "cls-8",
    x1: 184.38,
    y1: 0.13,
    x2: 184.38,
    y2: 283.59
  })), _line19 || (_line19 = /*#__PURE__*/React.createElement("line", {
    className: "cls-8",
    x1: 212.72,
    y1: 0.13,
    x2: 212.72,
    y2: 283.59
  })), _line20 || (_line20 = /*#__PURE__*/React.createElement("line", {
    className: "cls-8",
    x1: 241.07,
    y1: 0.13,
    x2: 241.07,
    y2: 283.59
  })), _line21 || (_line21 = /*#__PURE__*/React.createElement("line", {
    className: "cls-8",
    x1: 269.42,
    y1: 0.13,
    x2: 269.42,
    y2: 283.59
  })), _line22 || (_line22 = /*#__PURE__*/React.createElement("line", {
    className: "cls-8",
    x1: 0.12,
    y1: 255.24,
    x2: 567.05,
    y2: 255.24
  })), _line23 || (_line23 = /*#__PURE__*/React.createElement("line", {
    className: "cls-8",
    x1: 0.12,
    y1: 226.9,
    x2: 567.05,
    y2: 226.9
  })), _line24 || (_line24 = /*#__PURE__*/React.createElement("line", {
    className: "cls-8",
    x1: 0.12,
    y1: 198.55,
    x2: 567.05,
    y2: 198.55
  })), _line25 || (_line25 = /*#__PURE__*/React.createElement("line", {
    className: "cls-8",
    x1: 0.12,
    y1: 170.2,
    x2: 567.05,
    y2: 170.2
  })), _line26 || (_line26 = /*#__PURE__*/React.createElement("line", {
    className: "cls-8",
    x1: 0.13,
    y1: 141.86,
    x2: 567.05,
    y2: 141.86
  })), _line27 || (_line27 = /*#__PURE__*/React.createElement("line", {
    className: "cls-8",
    x1: 0.13,
    y1: 113.51,
    x2: 567.05,
    y2: 113.51
  })), _line28 || (_line28 = /*#__PURE__*/React.createElement("line", {
    className: "cls-8",
    x1: 0.13,
    y1: 85.16,
    x2: 567.05,
    y2: 85.16
  })), _line29 || (_line29 = /*#__PURE__*/React.createElement("line", {
    className: "cls-8",
    x1: 0.13,
    y1: 56.82,
    x2: 567.05,
    y2: 56.82
  })), _line30 || (_line30 = /*#__PURE__*/React.createElement("line", {
    className: "cls-8",
    x1: 0.13,
    y1: 28.47,
    x2: 567.05,
    y2: 28.47
  })), _line31 || (_line31 = /*#__PURE__*/React.createElement("line", {
    className: "cls-8",
    x1: 0.12,
    y1: 269.42,
    x2: 567.05,
    y2: 269.42
  })), _line32 || (_line32 = /*#__PURE__*/React.createElement("line", {
    className: "cls-8",
    x1: 0.12,
    y1: 241.07,
    x2: 567.05,
    y2: 241.07
  })), _line33 || (_line33 = /*#__PURE__*/React.createElement("line", {
    className: "cls-8",
    x1: 0.12,
    y1: 212.72,
    x2: 567.05,
    y2: 212.72
  })), _line34 || (_line34 = /*#__PURE__*/React.createElement("line", {
    className: "cls-8",
    x1: 0.12,
    y1: 184.38,
    x2: 567.05,
    y2: 184.38
  })), _line35 || (_line35 = /*#__PURE__*/React.createElement("line", {
    className: "cls-8",
    x1: 0.12,
    y1: 156.03,
    x2: 567.05,
    y2: 156.03
  })), _line36 || (_line36 = /*#__PURE__*/React.createElement("line", {
    className: "cls-8",
    x1: 0.13,
    y1: 127.68,
    x2: 567.05,
    y2: 127.68
  })), _line37 || (_line37 = /*#__PURE__*/React.createElement("line", {
    className: "cls-8",
    x1: 0.13,
    y1: 99.34,
    x2: 567.05,
    y2: 99.34
  })), _line38 || (_line38 = /*#__PURE__*/React.createElement("line", {
    className: "cls-8",
    x1: 0.13,
    y1: 70.99,
    x2: 567.05,
    y2: 70.99
  })), _line39 || (_line39 = /*#__PURE__*/React.createElement("line", {
    className: "cls-8",
    x1: 0.13,
    y1: 42.64,
    x2: 567.05,
    y2: 42.64
  })), _line40 || (_line40 = /*#__PURE__*/React.createElement("line", {
    className: "cls-8",
    x1: 0.13,
    y1: 14.3,
    x2: 567.05,
    y2: 14.3
  })), _line41 || (_line41 = /*#__PURE__*/React.createElement("line", {
    className: "cls-8",
    x1: 567.05,
    y1: 0.13,
    x2: 567.05,
    y2: 283.59
  })), _line42 || (_line42 = /*#__PURE__*/React.createElement("line", {
    className: "cls-8",
    x1: 311.94,
    y1: 0.13,
    x2: 311.94,
    y2: 283.59
  })), _line43 || (_line43 = /*#__PURE__*/React.createElement("line", {
    className: "cls-8",
    x1: 340.28,
    y1: 0.13,
    x2: 340.28,
    y2: 283.59
  })), _line44 || (_line44 = /*#__PURE__*/React.createElement("line", {
    className: "cls-8",
    x1: 368.63,
    y1: 0.13,
    x2: 368.63,
    y2: 283.59
  })), _line45 || (_line45 = /*#__PURE__*/React.createElement("line", {
    className: "cls-8",
    x1: 396.98,
    y1: 0.13,
    x2: 396.98,
    y2: 283.59
  })), _line46 || (_line46 = /*#__PURE__*/React.createElement("line", {
    className: "cls-8",
    x1: 425.32,
    y1: 0.13,
    x2: 425.32,
    y2: 283.59
  })), _line47 || (_line47 = /*#__PURE__*/React.createElement("line", {
    className: "cls-8",
    x1: 453.67,
    y1: 0.13,
    x2: 453.67,
    y2: 283.59
  })), _line48 || (_line48 = /*#__PURE__*/React.createElement("line", {
    className: "cls-8",
    x1: 482.01,
    y1: 0.13,
    x2: 482.01,
    y2: 283.59
  })), _line49 || (_line49 = /*#__PURE__*/React.createElement("line", {
    className: "cls-8",
    x1: 510.36,
    y1: 0.13,
    x2: 510.36,
    y2: 283.59
  })), _line50 || (_line50 = /*#__PURE__*/React.createElement("line", {
    className: "cls-8",
    x1: 538.71,
    y1: 0.13,
    x2: 538.71,
    y2: 283.59
  })), _line51 || (_line51 = /*#__PURE__*/React.createElement("line", {
    className: "cls-8",
    x1: 297.76,
    y1: 0.13,
    x2: 297.76,
    y2: 283.59
  })), _line52 || (_line52 = /*#__PURE__*/React.createElement("line", {
    className: "cls-8",
    x1: 326.11,
    y1: 0.13,
    x2: 326.11,
    y2: 283.59
  })), _line53 || (_line53 = /*#__PURE__*/React.createElement("line", {
    className: "cls-8",
    x1: 354.46,
    y1: 0.13,
    x2: 354.46,
    y2: 283.59
  })), _line54 || (_line54 = /*#__PURE__*/React.createElement("line", {
    className: "cls-8",
    x1: 382.8,
    y1: 0.13,
    x2: 382.8,
    y2: 283.59
  })), _line55 || (_line55 = /*#__PURE__*/React.createElement("line", {
    className: "cls-8",
    x1: 411.15,
    y1: 0.13,
    x2: 411.15,
    y2: 283.59
  })), _line56 || (_line56 = /*#__PURE__*/React.createElement("line", {
    className: "cls-8",
    x1: 439.5,
    y1: 0.13,
    x2: 439.5,
    y2: 283.59
  })), _line57 || (_line57 = /*#__PURE__*/React.createElement("line", {
    className: "cls-8",
    x1: 467.84,
    y1: 0.13,
    x2: 467.84,
    y2: 283.59
  })), _line58 || (_line58 = /*#__PURE__*/React.createElement("line", {
    className: "cls-8",
    x1: 496.19,
    y1: 0.13,
    x2: 496.19,
    y2: 283.59
  })), _line59 || (_line59 = /*#__PURE__*/React.createElement("line", {
    className: "cls-8",
    x1: 524.53,
    y1: 0.13,
    x2: 524.53,
    y2: 283.59
  })), _line60 || (_line60 = /*#__PURE__*/React.createElement("line", {
    className: "cls-8",
    x1: 552.88,
    y1: 0.13,
    x2: 552.88,
    y2: 283.59
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGuideMaterial13);
export default __webpack_public_path__ + "static/media/guideMaterial13.bc0361e800311c89e01e0d57f5ff60fe.svg";
export { ForwardRef as ReactComponent };